import React, { Component } from 'react';
import '../../../src/styles/Journals.css';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { Collapse } from 'react-bootstrap';
import '../../../src/styles/Manual.css';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal'
import queryString from 'query-string';
import { appService } from '../../_services';
import { Button } from 'react-bootstrap';
import ChapterModal from 'react-bootstrap/Modal'
import { authHeader, config } from '../../_helpers'
import DocumentMeta from 'react-document-meta';
import { faIR } from 'date-fns/locale';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Redirect, Route } from 'react-router-dom';
import * as axios from 'axios';
import EmailModal from 'react-bootstrap/Modal';
import { Maintenance } from '../Maintenance/Maintenance.jsx';
import ReactGA from 'react-ga';
import Spinner from '../Spinner';
import RankingTag from './Subitems/RankingTag'

let PathIssue = '', url = '', params = '', path = '', getIssues = '', getNextIssues = '', getNextAllIssues: '', getAllIssues = '', Allissues = '', issues = '', VolumeId = '', ProductId = '', parameters = '', newcurrency = '', Emailparameters = "", PubDate = '';
var fileName = "", journalTitlePlus = "", useragent = navigator.userAgent;
let meta = '';
var TabStyle = {
    paddingLeft: '4%',
    paddingRight: '4%'
}
var Displaystyle = {
    display: 'inline-block'
}
var Stylearticle = {
    paddingLeft: '0px',
    paddingTop: '2%'
}


export class JournalPublication extends Component {

    displayName = JournalPublication.name
    constructor(props) {
        super(props);
        this.state = { //this is a temporary fix for hiding/showing links if not logged in -  condition will be modified 
            login: false, Subscribed: false,
            show: false,
            journalIssues: "", AlljournalIssues: '', Issueslist: '',
            journalVolumes: "", AlljournalVolumes: '', Volumelist: '', NextVolumelist: '',
            journalArticles: "",
            prodid: "",
            volno: "",
            Issuetext: '', IssuetextNo: '',
            year: "",
            showPdfUrl: true,
            TotalArticle: '',
            OnlinePrice: '',
            printedmaterial: '', PdfPrice: '',
            redirectToSearch: false,
            user: '', TopicId: '', TopicName: '', issueID: '', BulletPoint1: '', BulletPoint2: '', BulletPoint3: ''
        }
        this.state = {
            email: 'dawn.danish@wolterskluwer.com',
        };
        this.state = { showText: false };
        this.state = { showissue: false };
        this.state = {
            checked: false,
            checked1: true,
            journalTitle: "",
            journalImage: [],
            journalDesc: [],
            journalMainEditors: [],
            journalEditors: [],
            aboutJournal: [],
            whatsNew: [],
            authorGuidelines: [],
            volumes: [],
            articles: [],
            allissues: [],
            issues: [],
            productprice: [],
            LatestIssue: [],
            link: '',
            code: "",
            samplePDF: [], ShowSublist: [],
            emailReciepient: '',
            metaDescription: '', metaTitle: '', authorGuidelineFile: '', editorFile: '', emailRec: '', emailName: '', IsError: false,
            redirectToLogin: false,
            searchAuthor: "",
            loading: false,
            isVolumeLoaded: false
        };

        this.onChange = this.onChange.bind(this);
        this.onChange1 = this.onChange1.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        //this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChapterModalShow = this.handleChapterModalShow.bind(this);
        this.handleChapterModalClose = this.handleChapterModalClose.bind(this);
        this.renderxml = this.renderxml.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.searchAuthorContent = this.searchAuthorContent.bind(this);
        this.handleEmailModalShow = this.handleEmailModalShow.bind(this);
        this.handleEmailModalClose = this.handleEmailModalClose.bind(this);
        this.sendShareByEmail = this.sendShareByEmail.bind(this)
        this.handleEmailValidation = this.handleEmailValidation.bind(this);
        //this.HandleVolumeClick = this.HandleVolumeClick.bind(this);
        //this.GetSubLevels = this.GetSubLevels.bind(this);
        this.BindSIQEvent = this.BindSIQEvent.bind(this);
        this.logoutsession = this.logoutsession.bind(this);
    }
    logoutsession() {

        var self = this;
        if (localStorage.getItem('user') !== null) {
            appService.getAll('/User/logOutDecreseActiveCount').then(function (response) {
                appService.getAll('/User/logOut').then(function (response) {

                    //localStorage.removeItem('user');
                    //localStorage.removeItem('userId');
                    //localStorage.removeItem('usersubscription');
                    //localStorage.removeItem('company');
                    //localStorage.removeItem('firstName');
                    //localStorage.removeItem('lastName');
                    //localStorage.removeItem('salesForceID');
                    localStorage.clear();
                    localStorage.setItem('logoutclick', 'true');

                });
                window['LastURL'] = '';
            });

        }
        self.setState({
            redirectToLogin: true
        })
    }
    BindSIQEvent(key) {
        var prdTitle = typeof this.props.match.params.title != "undefined" ? this.props.match.params.title.replace(/\+/g, " ") : "";

        if (key == "Issues") {
            if (localStorage.getItem('user') !== null) {
                window['NTPT_PGEXTRA'] = 'event_type=all_issues&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
            else {
                window['NTPT_PGEXTRA'] = 'event_type=all_issues&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + ' &Subscribed=false' + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
        }

        if (key == "About journal") {
            if (localStorage.getItem('user') !== null) {
                window['NTPT_PGEXTRA'] = 'event_type=journal_abstract&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
            else {
                window['NTPT_PGEXTRA'] = 'event_type=journal_abstract&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + ' &Subscribed=false' + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
        }

        if (key == "Editors") {
            if (localStorage.getItem('user') !== null) {
                window['NTPT_PGEXTRA'] = 'event_type=all_editors&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
            else {
                window['NTPT_PGEXTRA'] = 'event_type=all_editors&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + ' &Subscribed=false' + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
        }

        if (key == "AuthorGuide") {
            if (localStorage.getItem('user') !== null) {
                window['NTPT_PGEXTRA'] = 'event_type=author_guidelines&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
            else {
                window['NTPT_PGEXTRA'] = 'event_type=author_guidelines&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + ' &Subscribed=false' + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
        }

      //  if (key == "PrePublication") {
      //    if (localStorage.getItem('user') !== null) {
      //        window['NTPT_PGEXTRA'] = 'event_type=pre_publication&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
      //        const script = document.createElement("script");
      //        script.src = "/siqpagetag.js";
      //        script.async = true;
      //        document.body.appendChild(script);
      //    }
      //    else {
      //        window['NTPT_PGEXTRA'] = 'event_type=pre_publication&ProductId=' + this.props.match.params.id + ' &ProductTitle=' + prdTitle + ' &Subscribed=false' + '&platform=klo &useragent=' + useragent;
      //        const script = document.createElement("script");
      //        script.src = "/siqpagetag.js";
      //        script.async = true;
      //        document.body.appendChild(script);
      //    }
      //}
        var msg = {
            ArticleTitle: window['NTPT_PGEXTRA']
        }
        var Logurl = 'Product/LogData';
        appService.submit(Logurl, msg).then(function (data) {

        });

    }

    handleEmailValidation() {
        var self = this;
        let fields = self.state.fields;
        let errors = {};
        let formIsValid = true;

        var emailTo = this.refs["email"].value;

        if (emailTo == "") {
            formIsValid = false;
            this.state.emailRec = "* Required field";
        }

        if (emailTo != "") {
            var emails = emailTo.split(";");
            emails.forEach(function (emails) {
                let lastAtPos = emails.lastIndexOf('@');
                let lastDotPos = emails.lastIndexOf('.');

                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emails.indexOf('@@') == -1 && lastDotPos > 2 && (emails.length - lastDotPos) > 2)) {
                    formIsValid = false;
                    self.state.emailRec = "* Please enter a valid email address";
                }
            })
        }
        self.setState({ errors: errors });

        return formIsValid;

    }

    sendShareByEmail() {
        if (this.handleEmailValidation()) {
            this.state.emailRec = '';
            Emailparameters = {
                Email: this.refs["email"].value,
                Subject: this.refs["SubjectTitle"].value == "" ? this.state.journalTitle : this.refs["SubjectTitle"].value,
                Category: window.location.href,
                AdditionalInfo: this.refs["AddInfo"].value
            }
            var self = this;
            appService.submit('/Email/ShareByEmail', Emailparameters)
                .then(function (data) {
                    if (data == "Success") {
                        self.setState({ handleEmailModalShow: false });
                    }
                });
        }
    }

    decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }
    searchAuthorContent = (e) => {
        this.state.searchAuthor = e;
        //window['SearchAuthor'] = e;
        this.setState({ redirectToSearch: true });
    }


    onChange(e) {
        this.setState({ 'checked': e.target.checked });
    }

    renderxml(e) {


    }

    onChange1(e) {
        this.setState({ 'checked1': e.target.checked });
    }

    handleSelect(e) {
        window.scrollTo(0, 0);
        //console.log(this.state.journalTitle);

    }
    handleClose() {
        this.setState({ show: false, emailName: '', emailReciepient: '' });
    }
    handleShow(e) {
        fileName = "Journals\\" + this.state.code + "\\" + e;
        this.setState({ show: true });
    }

    handleChapterModalClose() {
        this.setState({ handleChapterModalShow: false });
    }
    handleEmailModalClose() {
        this.setState({ handleEmailModalShow: false });
    }

    handleEmailModalShow() {
        this.setState({ handleEmailModalShow: true });
    }

    sendEmail() {
        localStorage.setItem('link', JSON.stringify(window.location.href));
        window.scrollTo(0, 0);
    }
    async handleChapterModalShow() {

        if (this.state.checked == false && this.state.checked1 == false) {
            alert('Please choose your subscription ');
        }
        else {

            const requestOptionsCountry = {

                headers: authHeader(),

            };

            const response = await fetch("https://ipapi.co/json/", requestOptionsCountry);
            const json = await response.json();
            this.setState({ currency: json.currency });

            const requestOptions = {
                method: 'POST',
                headers: authHeader(),
                body: {},
            };
            // url = this.props.location.search;
            // params = queryString.parse(url);

            let ProductId = document.location.pathname.split("/")[3];

            var self = this;
            fetch(config.apiUrl + '/Cart/AddToCart?IsProductId=true&ProductId=' + ProductId + '&OnlineThreeMonthsDelivery=' + this.state.checked + '&PrintDelivery=' + this.state.checked1 + '&currency=' + this.state.currency, requestOptions)
                .then(function (data) {
                    self.setState({ handleChapterModalShow: true });
                });

        }
    }

    openInNewTab(url) {
        axios(url, {
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            window.open(url);
        });
    }

    componentDidMount() {
        //Pradip Lalvani
        if (localStorage.getItem('user') !== null) {
            this.state.login = true;
        }
        else {
            this.state.login = false;
        }
        url = this.props.location.search;
        //params = queryString.parse(url);
        //alert(this.props.match.params.id);
        var self = this;
        this.state.user = JSON.parse(localStorage.getItem('user')); //Pradip Lalvani

        if (this.props.match.params.title) {
            if (this.props.match.params.title.includes(" ")) {
                var titlep = this.props.match.params.title.replace(/ /g, "+");
                window.location.href = 'Journals/' + titlep + '/' + this.props.match.params.id;
            }
        }

        if (this.props.match.params.id) {
            parameters = { ProductId: this.props.match.params.id, user: this.state.user };
            self.setState({ prodid: this.props.match.params.id });
        } else {
            params = queryString.parse(url);
            parameters = { ProductId: params.id, user: this.state.user };
            self.setState({ prodid: params.id });
        }

        appService.getByIssueId('Product/GetJournal', parameters) //Pradip Lalvani
            .then(function (data) {
                if (data == "Error found") {
                    // window.location = "/Maintenance";
                    self.setState({ IsError: true });
                }

                else {


                    self.setState({ samplePDF: data.samplePDF });
                    self.setState({ journaldetails: data });
                    self.setState({ journalTitle: data.title });
                    self.setState({ journalImage: data.imageUrl });
                    self.setState({ journalDesc: data.description });
                    self.setState({ Subscribed: data.subscribed }) //Pradip Lalvani
                    self.setState({ journalMainEditors: data.mainEditors });
                    self.setState({ journalEditors: data.editors });
                    self.setState({ aboutJournal: data.aboutJournal });
                    self.setState({ authorGuidelines: data.authorGuidelines });
                    self.setState({ whatsNew: data.whatsNew });
                    //self.setState({ volumes: data.volumes });
                    self.setState({ articles: data.articles });
                    self.setState({ LatestIssue: data.latestIssue });
                    self.setState({ code: data.code });
                    self.setState({ ranking: data.ranking });
                    self.setState({ metaTitle: data.metaTitle });
                    self.setState({ metaDescription: data.metaDescription });
                    self.setState({ BulletPoint1: data.bulletPoint1 });
                    self.setState({ BulletPoint2: data.bulletPoint2 });
                    self.setState({ BulletPoint3: data.bulletPoint3 });
                    self.setState({ authorGuidelineFile: data.authorGuidelineFile });
                    self.setState({ editorFile: data.editorFile });

                    if (data.latestIssue != undefined) {

                        self.setState({ volno: data.latestIssue.volumeNo });
                        self.setState({ year: data.latestIssue.year });
                    }

                    let prePublicationIssues = [];

                    data.latestIssue.issues.map((item, index) => {
                        // console.log(data.latestIssue.issues);
                        //console.log(data.articles);
                        //self.setState({ TotalArticle: data.articles.length });
                        self.setState({ issueNo: item.issueNo });
                        self.setState({ Issuetext: item.issueText });
                        self.setState({ issueID: item.id });
                        self.setState({ IssuetextNo: item.issueTextNo });

                       if(item[index].issueText.includes("[pre-publication]")){
                        prePublicationIssues.push(item);
                       }
                         
                    })

                    self.setState({ productprice: data.productPrice });
                    self.setState({ allissues: data.LatestIssue });
                    self.setState({ topicid: data.topicId });
                    self.setState({ topic: data.topic });
                    self.setState({ showPdfUrl: true });
                    self.setState({ TopicId: data.topicId });
                    self.setState({ TopicName: data.topic });

                    fetch("https://ipapi.co/json/")
                        .then(res => res.json())
                        .then(
                            (result) => {
                                //console.log(result)
                                newcurrency = result.currency;
                            });

                    self.state.productprice.map((item) => {
                        //console.log(item);

                        if (newcurrency == "EURO" || newcurrency == "INR" || newcurrency == '') {

                            if (item.type == "2") {
                                self.setState({ OnlinePrice: item.euro });
                            }
                            if (item.type == "3") {
                                self.setState({ printedmaterial: item.euro });
                            }
                            if (item.type == "1") {
                                self.setState({ PdfPrice: item.euro });
                            }
                        }
                        else if (newcurrency == "POUND") {

                            if (item.type == "2") {
                                self.setState({ OnlinePrice: item.pound });
                            }
                            if (item.type == "3") {
                                self.setState({ printedmaterial: item.pound });
                            }
                            if (item.type == "1") {
                                self.setState({ PdfPrice: item.pound });
                            }
                        }
                        else {

                            if (item.type == "2") {
                                self.setState({ OnlinePrice: item.usd });
                            }
                            if (item.type == "3") {
                                self.setState({ printedmaterial: item.usd });
                            }
                            if (item.type == "1") {
                                self.setState({ PdfPrice: item.usd });
                            }
                        }


                    }
                    )

                    var prdTitles = typeof self.props.match.params.title != "undefined" ? self.props.match.params.title.replace(/\+/g, " ") : "";

                    if (localStorage.getItem('user') !== null) {
                        window['NTPT_PGEXTRA'] = 'event_type=all_issues&ProductId=' + self.props.match.params.id + ' &ProductTitle=' + prdTitles + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                        const script = document.createElement("script");
                        script.src = "/siqpagetag.js";
                        script.async = true;
                        document.body.appendChild(script);
                    }
                    else {
                        window['NTPT_PGEXTRA'] = 'event_type=all_issues&ProductId=' + self.props.match.params.id + ' &ProductTitle=' + prdTitles + ' &User= &Subscribed=' + data.subscribed + '&platform=klo &useragent=' + useragent;
                        const script = document.createElement("script");
                        script.src = "/siqpagetag.js";
                        script.async = true;
                        document.body.appendChild(script);
                    }
                    var msg = {
                        ArticleTitle: window['NTPT_PGEXTRA']
                    }
                    var Logurl = 'Product/LogData';
                    appService.submit(Logurl, msg).then(function (data) {

                    });
                }

                ReactGA.initialize(
                    [
                        {
                            trackingId: 'UA-2905701-8',
                            gaOptions: { name: 'tracker1' }
                        },
                        {
                            trackingId: 'UA-72849501-2',
                            gaOptions: { name: 'tracker2' }
                        }
                    ],
                    { alwaysSendToDefaultTracker: false }
                );

                ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], data.title + " - Kluwer Law Online");
                var metas = document.getElementsByTagName('meta');
                for (let i = 0; i < metas.length; i++) {
                    if (metas[i].getAttribute('name') == "robots") {
                        console.log(metas[i]);
                        metas[i].remove();
                    }
                }
                //self.setState({ loading: true });
                //appService.getByIssueId('Product/GetVolume', parameters) //Pradip Lalvani
                //    .then(function (data) {
                //        if (data == "Error found") {
                //            this.setState({ IsError: true });
                //        }
                //        else {
                //            self.setState({ volumes: data.volumes });
                //            self.setState({ loading: false });
                //        }
                //    });
            });


        document.addEventListener('scroll', this.trackScrolling);
        //.replace(/<[^>]*>/g, "")
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.trackScrolling);
    }

    trackScrolling = () => {
        var self = this;
        var isPortableDevice = false;
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            isPortableDevice = true;
        }
        if (isPortableDevice) {
            if (!this.state.isVolumeLoaded) {
                //alert(document.body.offsetHeight);
                if ((window.innerHeight + window.scrollY) >= 2200) {
                    if (this.props.match.params.id) {
                        parameters = { ProductId: this.props.match.params.id, user: this.state.user };
                        this.setState({ prodid: this.props.match.params.id });
                    } else {
                        params = queryString.parse(url);
                        parameters = { ProductId: params.id, user: this.state.user };
                        this.setState({ prodid: params.id });
                    }
                    self.setState({ isVolumeLoaded: true });
                    self.setState({ loading: true });
                    appService.getByIssueId('Product/GetVolume', parameters) //Pradip Lalvani
                        .then(function (data) {
                            if (data == "Error found") {
                                this.setState({ IsError: true });
                            }
                            else {
                                self.setState({ volumes: data.volumes });
                                self.setState({ loading: false });
                            }
                        });
                }

            }
        }
        else {
            if ((/Mac|Macintosh/i.test(navigator.userAgent))) {
                
                if (!this.state.isVolumeLoaded) {
                    if ((window.innerHeight + window.scrollY) >= 650) {                       
                        if (this.props.match.params.id) {
                            parameters = { ProductId: this.props.match.params.id, user: this.state.user };
                            this.setState({ prodid: this.props.match.params.id });
                        } else {
                            params = queryString.parse(url);
                            parameters = { ProductId: params.id, user: this.state.user };
                            this.setState({ prodid: params.id });
                        }
                        self.setState({ isVolumeLoaded: true });
                        self.setState({ loading: true });
                        appService.getByIssueId('Product/GetVolume', parameters) //Pradip Lalvani
                            .then(function (data) {
                                if (data == "Error found") {
                                    this.setState({ IsError: true });
                                }
                                else {
                                    self.setState({ volumes: data.volumes });
                                    self.setState({ loading: false });
                                }
                            });
                    }
                }
            }
            else {
                if (!this.state.isVolumeLoaded) {
                    if ((window.innerHeight + window.scrollY) >= 600) {                        
                        if (this.props.match.params.id) {
                            parameters = { ProductId: this.props.match.params.id, user: this.state.user };
                            this.setState({ prodid: this.props.match.params.id });
                        } else {
                            params = queryString.parse(url);
                            parameters = { ProductId: params.id, user: this.state.user };
                            this.setState({ prodid: params.id });
                        }
                        self.setState({ isVolumeLoaded: true });
                        self.setState({ loading: true });
                        appService.getByIssueId('Product/GetVolume', parameters) //Pradip Lalvani
                            .then(function (data) {
                                if (data == "Error found") {
                                    this.setState({ IsError: true });
                                }
                                else {
                                    self.setState({ volumes: data.volumes });
                                    self.setState({ loading: false });
                                }
                            });
                    }
                }
            }
            
        }
    }

    //Start:Pradip Lalvani -New
    handleValidation() {
        var self = this;
        //let fields = self.state.fields;
        //let errors = {};
        let formIsValid = true;

        var emailTo = this.refs["emailTo"].value;
        //var Body = this.refs["Body"].value;
        //var emailTo = this.refs["emailTo"].value;
        //var Body = this.refs["Body"].value;
        var emailName = this.refs["emailName"].value;

        if (emailName == "") {
            formIsValid = false;
            this.state.emailName = "* Required field";
        }
        else {
            this.state.emailName = "";
        }
        if (emailTo == "") {
            formIsValid = false;
            this.setState({
                emailReciepient: "* Required field"
            });
            //this.state.emailReciepient = "* Required field";
        }

        if (emailTo != "") {
            let lastAtPos = emailTo.lastIndexOf('@');
            let lastDotPos = emailTo.lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emailTo.indexOf('@@') == -1 && lastDotPos > 2 && (emailTo.length - lastDotPos) > 2)) {
                formIsValid = false;
                this.setState({
                    emailReciepient: "* Please enter a valid email address"
                });
                //this.state.emailReciepient = "* Please enter a valid email address";
            }
        }

        //self.setState({ errors: errors });
        if (!formIsValid) {
            window.scrollTo({
                top: 200,
                behavior: 'smooth',
            });
            return false;
        }

        return true;
    }


    handleSubmit(event) {
        //event.preventDefault();
        if (this.handleValidation()) {
            this.state.emailName = '';
            this.state.emailReciepient = '';
            var emailTo = this.refs["emailTo"].value;
            var Body = 'Dear ' + this.refs["emailName"].value + ",";
            var Subject = this.state.Subject;
            var isNotForLink = true;

            parameters = { To: emailTo, Body: Body, Subject: Subject, isNotForLink: isNotForLink, FileName: fileName };

            appService.getByIssueId('/Email/SendEmail', parameters)
                .then(function (data) {

                    if (data == "Success") {
                        //  alert(5);
                        window.location = "/ThankyouSubscription";
                    }
                });
        }
        else {
            return false;
        }
        this.setState({ show: false });
    }
    //End:Pradip Lalvani -New

    stingBreakLine(str, length, ending) {
        //console.log(str.length);
        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = '...';
        }

        if (str != null && str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };

    HandleVolumeClick(id, e) {
        if (this.state.ShowSublist.some(item => id === item) &&
            e.target.className === "fa fa-minus") {

            let index = this.state.ShowSublist.indexOf(id);
            e.target.className = "fa fa-plus";
            if (index > -1) {
                this.state.ShowSublist.splice(index, 1);
                this.setState({ ShowSublist: this.state.ShowSublist });
            };

        }
        else {
            let options = this.state.ShowSublist;
            options.push(id);
            e.target.className = "fa fa-minus";
            this.setState({
                ShowSublist: options
            })
        }

    }

    GetSubLevels(id, e) {
        if (this.state.ShowSublist.some(item => id === item)) {

            let index = this.state.ShowSublist.indexOf(id);
            e.target.previousSibling.className = "fa fa-plus";
            if (index > -1) {
                this.state.ShowSublist.splice(index, 1);
                this.setState({ ShowSublist: this.state.ShowSublist });
            };

        }
        else {
            let options = this.state.ShowSublist;
            options.push(id);
            e.target.previousSibling.className = "fa fa-minus";
            this.setState({
                ShowSublist: options
            })


        }

    }

    //renderSamplePDF = () => {
    //    return this.state.samplePDF !== undefined && Object.entries(this.state.samplePDF).map((item, index) => {
    //        return <div className="TopicBorder" id="Samplearticle">
    //            <br></br>
    //            <p className="paddingL" style={{ margin: '0' }}>
    //                <a className="LinkClass margintop HoverUnderline" style={{ cursor: 'pointer' }} onClick={(e) => this.handleShow(item[1].fileName)} dangerouslySetInnerHTML={{ __html: item[1].articleTitle }}></a> (PDF)
    //                    </p><br></br>
    //        </div>

    //    })
    //}

    renderArticle = () => {
        return this.state.articles != null ?

            this.state.journalArticles = this.state.articles.slice(0, 5).map((item, index) => {

                const authorNames = item.authors != null && item.authors != 'undefined' && item.authors.map((authoritem, index) => {
                    return index == 0 ?
                        <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}> <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                        </span >
                        :
                        <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}>, <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                        </span >
                })

                return <div style={{ marginBottom: '15px', marginTop: '15px' }}><Link to={"/journalarticle/" + journalTitlePlus + "/" + this.state.volno + "." + this.state.issueNo + "/" + item.docId} className="LinkClass" onClick={this.handleSelect} dangerouslySetInnerHTML={{ __html: item.title }} style={{ fontSize: '17px', fontWeight: 'bold' }}></Link> <span>(p. {item.firstPage})</span>
                    <div className="LinkClass">{authorNames} </div>
                    <div dangerouslySetInnerHTML={{ __html: this.stingBreakLine(item.description, 245, '...') }}></div>
                </div>

            })
            :
            null
    }

    renderVolume = () => {
        return this.state.volumes != null ?
            this.state.volumes.slice(0, 20).map((item, index) => {
                getIssues = item.issues;
                return <div>
                    <i style={{ fontSize: '15px', color: '#007AC3', cursor: 'pointer' }} className="fa fa-plus"
                        onClick={(e) => this.HandleVolumeClick(item.id, e)}></i>
                    <span onClick={(e) => this.GetSubLevels(item.id, e)} className="LinkClass" style={{ cursor: 'pointer', marginLeft: '3%' }}>Vol. {item.volumeNo} ({item.year})</span> {item.subscribed == true ? <img alt="" src={"/../../images/green-tick.svg"} /> : null}

                    {this.state.journalIssues =
                        this.state.ShowSublist.length > 0 ?
                            this.state.ShowSublist.map(Subitem =>
                                Subitem == item.id ?
                                    getIssues.map((item1) => {
                                        if (item1.volumeId == Subitem) {
                                            ProductId = this.state.prodid;
                                            //path = "/JournalIssue?Issueid=" + item1.id + "&Volumeid=" + item1.volumeId + "&Productid=" + ProductId;
                                            path = "/journalIssue/" + journalTitlePlus + "/" + item.volumeNo + "." + item1.issueTextNo + "/" + item1.id;

                                            if (this.state.issueNo === item1.issueNo) {
                                                //PathIssue = "/JournalIssue?Issueid=" + item1.id + "&Volumeid=" + item1.volumeId + "&Productid=" + ProductId;
                                                PathIssue = "/journalIssue/" + journalTitlePlus + "/" + item.volumeNo + "." + item1.issueTextNo + "/" + item1.id;
                                            }

                                            return <div style={{ paddingLeft: '10%' }}> <Link onClick={this.handleSelect} to={path} className="LinkClass">
                                                {item1.issueText != null ? item1.issueText : "Issue " + item1.issueNo}
                                            </Link> (p. {item1.articles[0].firstPage}) <br></br></div>
                                        }

                                    })
                                    :
                                    null
                            )
                            :
                            null

                    }

                </div>
            })
            :
            null

    }

    renderJournalVolume = () => {
        return this.state.volumes != null ?
            this.state.volumes.slice(20, 40).map((item, index) => {
                getNextIssues = item.issues;
                return <div>

                    <i style={{ fontSize: '15px', color: '#007AC3', cursor: 'pointer' }} className="fa fa-plus"
                        onClick={(e) => this.HandleVolumeClick(item.id, e)} ></i>
                    <span onClick={(e) => this.GetSubLevels(item.id, e)} className="LinkClass" style={{ cursor: 'pointer', marginLeft: '3%' }}>Vol. {item.volumeNo} ({item.year})</span> {item.subscribed == true ? <img alt="" src={"/../../images/green-tick.svg"} /> : null}
                    {this.state.AlljournalIssues =
                        this.state.ShowSublist.length > 0 ?
                            this.state.ShowSublist.map(Subitem =>
                                Subitem == item.id ?
                                    getNextIssues.map((item1) => {

                                        if (item1.volumeId == Subitem) {
                                            ProductId = this.state.prodid;
                                            //path = "/JournalIssue?Issueid=" + item1.id + "&Volumeid=" + item1.volumeId + "&Productid=" + ProductId;
                                            path = "/journalIssue/" + journalTitlePlus + "/" + item.volumeNo + "." + item1.issueTextNo + "/" + item1.id;

                                            if (this.state.issueNo === item1.issueNo) {
                                                //PathIssue = "/JournalIssue?Issueid=" + item1.id + "&Volumeid=" + item1.volumeId + "&Productid=" + ProductId;
                                                PathIssue = "/journalIssue/" + journalTitlePlus + "/" + item.volumeNo + "." + item1.issueTextNo + "/" + item1.id;
                                            }

                                            return <div style={{ paddingLeft: '10%' }}> <Link onClick={this.handleSelect} to={path} className="LinkClass">
                                                {item1.issueText != null ? item1.issueText : "Issue " + item1.issueNo}
                                            </Link> (p. {item1.articles[0].firstPage})<br></br></div>
                                        }

                                    })
                                    :
                                    null
                            )
                            :
                            null

                    }

                </div>
            })
            :
            null

    }

    renderVolumeList = () => {
        return this.state.volumes != null ?
            this.state.volumes.slice(40, 60).map((item, index) => {
                getNextIssues = item.issues;
                return <div>

                    <i style={{ fontSize: '15px', color: '#007AC3', cursor: 'pointer' }} className="fa fa-plus"
                        onClick={(e) => this.HandleVolumeClick(item.id, e)}></i>
                    <span onClick={(e) => this.GetSubLevels(item.id, e)} className="LinkClass" style={{ cursor: 'pointer', marginLeft: '3%' }}>Vol. {item.volumeNo} ({item.year})</span> {item.subscribed == true ? <img alt="" src={"/../../images/green-tick.svg"} /> : null}
                    {this.state.Issueslist =
                        this.state.ShowSublist.length > 0 ?
                            this.state.ShowSublist.map(Subitem =>
                                Subitem == item.id ?
                                    getNextIssues.map((item1) => {

                                        if (item1.volumeId == Subitem) {
                                            ProductId = this.state.prodid;
                                            //path = "/JournalIssue?Issueid=" + item1.id + "&Volumeid=" + item1.volumeId + "&Productid=" + ProductId;
                                            path = "/journalIssue/" + journalTitlePlus + "/" + item.volumeNo + "." + item1.issueTextNo + "/" + item1.id;

                                            if (this.state.issueNo === item1.issueNo) {
                                                //PathIssue = "/JournalIssue?Issueid=" + item1.id + "&Volumeid=" + item1.volumeId + "&Productid=" + ProductId;
                                                PathIssue = "/journalIssue/" + journalTitlePlus + "/" + item.volumeNo + "." + item1.issueTextNo + "/" + item1.id;
                                            }

                                            return <div style={{ paddingLeft: '10%' }}> <Link onClick={this.handleSelect} to={path} className="LinkClass">
                                                {item1.issueText != null ? item1.issueText : "Issue " + item1.issueNo}
                                            </Link> (p. {item1.articles[0].firstPage})<br></br></div>
                                        }

                                    })
                                    :
                                    null
                            )
                            :
                            null

                    }

                </div>
            })
            :
            null

    }

    renderNextVolume = () => {
        return this.state.volumes != null ?
            this.state.volumes.slice(60, this.state.volumes.length).map((item, index) => {
                getNextAllIssues = item.issues;
                return <div>

                    <i style={{ fontSize: '15px', color: '#007AC3', cursor: 'pointer' }} className="fa fa-plus"
                        onClick={(e) => this.HandleVolumeClick(item.id, e)}></i>
                    <span onClick={(e) => this.GetSubLevels(item.id, e)} className="LinkClass" style={{ cursor: 'pointer', marginLeft: '3%' }}>Vol. {item.volumeNo} ({item.year})</span> {item.subscribed == true ? <img alt="" src={"/../../images/green-tick.svg"} /> : null}
                    {this.state.NextIssueslist =
                        this.state.ShowSublist.length > 0 ?
                            this.state.ShowSublist.map(Subitem =>
                                Subitem == item.id ?
                                    getNextAllIssues.map((item1) => {

                                        if (item1.volumeId == Subitem) {
                                            ProductId = this.state.prodid;
                                            //path = "/JournalIssue?Issueid=" + item1.id + "&Volumeid=" + item1.volumeId + "&Productid=" + ProductId;
                                            path = "/journalIssue/" + journalTitlePlus + "/" + item.volumeNo + "." + item1.issueTextNo + "/" + item1.id;

                                            if (this.state.issueNo === item1.issueNo) {
                                                //PathIssue = "/JournalIssue?Issueid=" + item1.id + "&Volumeid=" + item1.volumeId + "&Productid=" + ProductId;
                                                PathIssue = "/journalIssue/" + journalTitlePlus + "/" + item.volumeNo + "." + item1.issueTextNo + "/" + item1.id;
                                            }

                                            return <div style={{ paddingLeft: '10%' }}> <Link onClick={this.handleSelect} to={path} className="LinkClass">
                                                {item1.issueText != null ? item1.issueText : "Issue " + item1.issueNo}
                                            </Link> (p. {item1.articles[0].firstPage})<br></br></div>
                                        }

                                    })
                                    :
                                    null
                            )
                            :
                            null

                    }

                </div>
            })
            :
            null
    }

    render() {
        if (this.state.IsError != true) {
            if (this.state.redirectToSearch) {
                this.setState({ redirectToSearch: false });
                return <Redirect to={"/SearchContent/query=?authorString=" + this.state.searchAuthor} />;
            }

            journalTitlePlus = typeof this.state.journalTitle == 'undefined' ? "" : this.state.journalTitle.replace(/ /g, "+");

            meta = {
                title: this.state.journalTitle + " - Kluwer Law Online",
                // description: this.state.metaDescription,
                canonical: window.location.href,
                //meta: {
                //    charset: "utf-8",
                //    name: {
                //        citation_title: this.props.match.params.title,
                //        citation_number: this.props.match.params.id,
                //        citation_main_editors: this.state.journalMainEditors,
                //        title: this.state.metaTitle,
                //        description: this.state.metaDescription
                //    }
                //}
            }
        }

        const renderSamplePDF = this.state.samplePDF !== undefined && Object.entries(this.state.samplePDF).map((item, index) => {

            return <div className="TopicBorder" id="Samplearticle">
                <br></br>
                <p className="paddingL" style={{ margin: '0' }}>
                    <a className="LinkClass margintop HoverUnderline" style={{ cursor: 'pointer' }} onClick={(e) => this.handleShow(item[1].fileName)} dangerouslySetInnerHTML={{ __html: item[1].articleTitle }}></a> (PDF)
                        </p><br></br>
            </div>

        })

        return this.state.IsError != true ? (
          <DocumentMeta {...meta}>
            <div>
              <div className="col-12">
                <div className="row">
                  <div className="col-lg-9">
                    <p className="TitlePadding SetPaddingforP">
                      <Link
                        to="/"
                        className="LinkClass"
                        onClick={this.handleSelect}
                      >
                        Home
                      </Link>{" "}
                      >{" "}
                      <Link
                        to="/AllJournals"
                        className="LinkClass"
                        onClick={this.handleSelect}
                      >
                        All journals
                      </Link>{" "}
                      > &nbsp;
                      <div
                        style={{ display: "inline-block" }}
                        dangerouslySetInnerHTML={{
                          __html: this.state.journalTitle,
                        }}
                      ></div>
                    </p>
                  </div>
                </div>

                <div className="row AllColPadding margintop">
                  <div className="row" style={{ width: "100%" }}>
                    <div className="col-lg-8" style={{ minWidth: "73%" }}>
                      <div className="JournalFlex">
                        <img
                          alt={"Cover Image for " + this.state.journalTitle}
                          src={"/../../images/books/" + this.state.journalImage}
                          className="TitleImg"
                        />
                        <div style={{ width: "100%" }}>
                          <h1
                            className="paddingL PublicationTitle"
                            dangerouslySetInnerHTML={{
                              __html: this.state.journalTitle,
                            }}
                          ></h1>
                          <p className="paddingL">
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  this.state.journalMainEditors == null
                                    ? ""
                                    : this.state.journalMainEditors,
                              }}
                            ></div>
                          </p>
                          <p className="paddingL">
                            <ul
                              className="ManualUl"
                              style={{ paddingLeft: "3%" }}
                            >
                              {this.state.BulletPoint1 !== null &&
                              this.state.BulletPoint1 !== "" ? (
                                <li
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.BulletPoint1,
                                  }}
                                ></li>
                              ) : null}
                              {this.state.BulletPoint2 !== null &&
                              this.state.BulletPoint2 !== "" ? (
                                <li
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.BulletPoint2,
                                  }}
                                ></li>
                              ) : null}
                              {this.state.BulletPoint3 !== null &&
                              this.state.BulletPoint3 !== "" ? (
                                <li
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.BulletPoint3,
                                  }}
                                ></li>
                              ) : null}
                            </ul>
                          </p>
                        </div>
                      </div>

                      <div className="White"></div>
                      <div className="row">
                        <div className="col-lg-12">
                          <Tabs
                            defaultActiveKey="Issues"
                            id="uncontrolled-tab-example"
                            className="flex-tabs Tabfont myClass"
                            onSelect={this.BindSIQEvent}
                          >
                            <Tab eventKey="Issues" title="Issues">
                              <br></br>

                              <h2>
                                <span className="ltIssue">Latest issue</span>
                              </h2>
                              <span
                                onClick={this.handleSelect}
                                className="ltIssue"
                              >
                                Vol. {this.state.volno} ({this.state.year}){" "}
                                {this.state.Issuetext != null
                                  ? this.state.Issuetext
                                  : "Issue " + this.state.issueNo}
                              </span>
                              {this.renderArticle()}

                              <div className="col-lg-12">
                                <div
                                  className="row"
                                  style={{ paddingBottom: "2%" }}
                                >
                                  <div
                                    className="col-lg-9"
                                    style={Stylearticle}
                                  >
                                    Showing{" "}
                                    {this.state.journalArticles.slice(0, 5) !=
                                    undefined
                                      ? this.state.journalArticles.length
                                      : 0}{" "}
                                    of {this.state.articles.length} articles
                                  </div>
                                  <div
                                    className="col-lg-3"
                                    style={{
                                      cursor: "pointer",
                                      textAlign: "-webkit-right",
                                    }}
                                  >
                                    <div class="btngroup Hoverclass">
                                      <button>
                                        {" "}
                                        <Link
                                          className="LinkClass"
                                          title="Full issue"
                                          to={
                                            "/journalIssue/" +
                                            journalTitlePlus +
                                            "/" +
                                            this.state.volno +
                                            "." +
                                            this.state.IssuetextNo +
                                            "/" +
                                            this.state.issueID
                                          }
                                        >
                                          Full issue{" "}
                                        </Link>
                                      </button>
                                      <button>
                                        {" "}
                                        <Link
                                          to={
                                            "/journalIssue/" +
                                            journalTitlePlus +
                                            "/" +
                                            this.state.volno +
                                            "." +
                                            this.state.IssuetextNo +
                                            "/" +
                                            this.state.issueID
                                          }
                                          onClick={this.handleSelect}
                                        >
                                          <i className="fas fa-arrow-right">
                                            <span class="sr-only sr-only-focusable">
                                              Arrow button used for open the
                                              Full issue
                                            </span>
                                          </i>
                                        </Link>{" "}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="row">
                                  <hr style={{ width: "100%" }}></hr>
                                </div>
                                <br></br>
                                <div className="row">
                                  <p>
                                    <span className="ltIssue">All issues</span>
                                  </p>
                                </div>
                                {this.state.volumes.length > 60 ? (
                                  <div
                                    className="row"
                                    style={{
                                      display: "table",
                                      clear: "both",
                                      width: "100%",
                                    }}
                                  >
                                    {this.state.loading ? <Spinner /> : null}
                                    <div
                                      className="column"
                                      style={{ float: "left", width: "25%" }}
                                    >
                                      {this.renderVolume()}
                                    </div>
                                    <div
                                      className="column"
                                      style={{ float: "left", width: "25%" }}
                                    >
                                      {this.renderJournalVolume()}
                                    </div>
                                    <div
                                      className="column"
                                      style={{ float: "left", width: "25%" }}
                                    >
                                      {this.renderVolumeList()}
                                    </div>
                                    <div
                                      className="column"
                                      style={{ float: "left", width: "25%" }}
                                    >
                                      {this.renderNextVolume()}
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className="row"
                                    style={{
                                      display: "table",
                                      clear: "both",
                                      width: "100%",
                                    }}
                                  >
                                    {this.state.loading ? <Spinner /> : null}
                                    <div
                                      className="column"
                                      style={{ float: "left", width: "33.33%" }}
                                    >
                                      {this.renderVolume()}
                                    </div>
                                    <div
                                      className="column"
                                      style={{ float: "left", width: "33.33%" }}
                                    >
                                      {this.renderJournalVolume()}
                                    </div>
                                    <div
                                      className="column"
                                      style={{ float: "left", width: "33.33%" }}
                                    >
                                      {this.renderVolumeList()}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </Tab>
                            <Tab eventKey="About journal" title="About journal">
                              <br></br>
                              <p>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.aboutJournal,
                                  }}
                                ></div>
                              </p>
                            </Tab>
                            <Tab eventKey="Editors" title="Editors">
                              <br></br>
                              <p>
                                <br></br>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.journalEditors,
                                  }}
                                ></div>
                              </p>
                            </Tab>
                            <Tab
                              eventKey="AuthorGuide"
                              title="Author guidelines"
                            >
                              <p>
                                <br></br>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.authorGuidelines,
                                  }}
                                ></div>
                              </p>
                            </Tab>
                            {this.state.whatsNew !== null &&
                            this.state.whatsNew !== "" ? (
                              <Tab
                                eventKey="Announcements"
                                title="Announcements"
                              >
                                <br></br>
                                <p>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.whatsNew,
                                    }}
                                  ></div>
                                </p>
                              </Tab>
                            ) : null}
                           {/*<Tab*/}
                           {/*   eventKey="PrePublication"*/}
                           {/*   title="Pre publication"*/}
                           {/* >*/}
                           {/*   <br></br>*/}

                           {/*   <span*/}
                           {/*     onClick={this.handleSelect}*/}
                           {/*     className="ltIssue"*/}
                           {/*   >*/}
                           {/*     Vol. {this.state.volno} ({this.state.year}){" "}*/}
                           {/*     {this.state.Issuetext != null*/}
                           {/*       ? this.state.Issuetext*/}
                           {/*       : "Issue " + this.state.issueNo}*/}
                           {/*   </span>*/}
                           {/*   {this.renderArticle()}*/}

                           {/* </Tab>*/}
                          </Tabs>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      {(!this.state.login && !this.state.Subscribed) ||
                      (this.state.login && !this.state.Subscribed) ? (
                        <div>
                          <div
                            className="TopicBorder BGGrey"
                            id="Subcribeto"
                            style={{
                              borderTop: "2px solid #CCCCCC",
                              paddingBottom: "3%",
                              paddingTop: "3%",
                              fontSize: "18px",
                            }}
                          >
                            <span className="paddingL fontbold margintop SetPaddingforP">
                              {" "}
                              Subscribe to this journal{" "}
                            </span>
                          </div>
                          <div className="TopicBorder" id="Pricemenu">
                            <p
                              className="paddingL fontbold"
                              style={{ lineHeight: "3", marginBottom: "3%" }}
                            >
                              Interested in a subscription?
                              <Link
                                to="/ContactSales"
                                variant="secondary"
                                style={{ marginTop: "3%", textAlign: "center" }}
                                className="Modalbutton Setwdth HoverUnderline"
                              >
                                {" "}
                                <strong> Contact our sales team</strong>{" "}
                              </Link>
                            </p>
                          </div>
                          {this.state.samplePDF !== undefined &&
                          this.state.samplePDF.length > 0 ? (
                            <div>
                              <div
                                className="TopicBorder BGGrey"
                                id="Takealook"
                                style={{
                                  paddingBottom: "2%",
                                  paddingTop: "2%",
                                  fontSize: "18px",
                                }}
                              >
                                <span className="paddingL fontbold margintop SetPaddingforP">
                                  {" "}
                                  Sample content{" "}
                                </span>
                              </div>
                              {renderSamplePDF}
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      <Modal
                        show={this.state.show}
                        onHide={this.handleClose}
                        {...this.props}
                        size="md"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header closeButton className="Popupcolor">
                          <Modal.Title>Sample content</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="col-8">
                            <label htmlFor="Name">Name</label>
                            <input
                              type="text"
                              className="form-control form-control-sm rounded-0"
                              ref="emailName"
                              placeholder="Enter your name"
                              id="Name"
                            />
                            <span className="errorMsg">
                              {this.state.emailName}
                            </span>
                          </div>
                          <br></br>
                          <div className="col-8">
                            <label htmlFor="Email">Email</label>
                            <input
                              type="text"
                              className="form-control form-control-sm rounded-0"
                              ref="emailTo"
                              placeholder="Enter your email"
                              id="Email"
                            />
                            <span className="errorMsg">
                              {this.state.emailReciepient}
                            </span>
                          </div>
                          <br></br>
                          <div className="col-8">
                            <a
                              href="http://www.kluwerlaw.com/terms-and-conditions/"
                              target="_blank"
                            >
                              Terms and Conditions
                            </a>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <div className="row">
                            <div className="col" style={{ paddingLeft: "6%" }}>
                              <span
                                variant="secondary"
                                className="Modalbutton HoverUnderline"
                                onClick={this.handleClose}
                              >
                                {" "}
                                Return to site{" "}
                              </span>
                            </div>
                            <div className="col TopicPadding">
                              <button
                                type="button"
                                className="btn btn-info next rounded-0"
                                onClick={this.handleSubmit}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </Modal.Footer>
                      </Modal>
                      <div
                        className="TopicBorder BGGrey"
                        style={{
                          paddingBottom: "3%",
                          paddingTop: "3%",
                          fontSize: "18px",
                        }}
                      >
                        <span className="paddingL fontbold margintop SetPaddingforP">
                          {" "}
                          Browse by practice area{" "}
                        </span>
                      </div>
                      <div className="TopicBorder">
                        <br></br>
                        {this.state.TopicName !== undefined ? (
                          <Link
                            to={
                              "/PracticeArea?Id=" +
                              this.state.TopicId +
                              "&name=" +
                              this.state.TopicName.replace(/ /g, "+")
                            }
                            onClick={this.handleSelect}
                            className="paddingL LinkClass margintop"
                            style={
                              this.state.TopicName.length > 33
                                ? Displaystyle
                                : null
                            }
                          >
                            {this.state.TopicName}{" "}
                          </Link>
                        ) : null}
                        <br></br> <br></br>
                      </div>
                      <div
                        className="TopicBorder BGGrey"
                        style={{
                          paddingBottom: "3%",
                          paddingTop: "3%",
                          fontSize: "18px",
                        }}
                      >
                        <span className="paddingL fontbold margintop SetPaddingforP">
                          {" "}
                          Share{" "}
                        </span>
                      </div>
                      <div className="TopicBorder">
                        <br></br>

                        <CopyToClipboard text={document.location.href}>
                          <span
                            data-tooltip="Share on Linkedin"
                            className="RSSCard Shareicon-margin"
                          >
                            <a
                              href={
                                "https://www.linkedin.com/shareArticle?mini=true&url=" +
                                window.location.href +
                                "&title=&summary=&source="
                              }
                              target="_blank"
                              title="Share on Linkedin"
                            >
                              <i
                                class="fa fa-linkedin shareicons colPadding btn-fa"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </span>
                        </CopyToClipboard>
                        <CopyToClipboard text={document.location.href}>
                          <span
                            data-tooltip="Share on Twitter"
                            className="RSSCard Shareicon-margin"
                          >
                            <a
                              href={
                                "https://twitter.com/home?status=" +
                                window.location.href
                              }
                              target="_blank"
                              title="Share on Twitter"
                            >
                              <i
                                class="fa fa-twitter shareicons colPadding btn-fa"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </span>
                        </CopyToClipboard>
                        <CopyToClipboard text={document.location.href}>
                          <span
                            data-tooltip="Share on Facebook"
                            className="RSSCard Shareicon-margin"
                          >
                            <a
                              href={
                                "https://www.facebook.com/sharer/sharer.php?u=" +
                                window.location.href
                              }
                              target="_blank"
                              title="Share on Facebook"
                            >
                              <i
                                class="fa fa-facebook shareicon-facebook colPadding btn-fa"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </span>
                        </CopyToClipboard>
                        {/* <span
                          onClick={this.handleEmailModalShow}
                          className="RSSCard Shareicon-margin"
                          data-tooltip="Share by Email"
                        >
                          <i
                            class="fa fa-envelope shareicons colPadding btn-fa"
                            aria-hidden="true"
                          ></i>
                        </span> */}
                        <br></br>
                        <br></br>
                      </div>

                      <EmailModal
                        show={this.state.handleEmailModalShow}
                        onHide={this.handleEmailModalClose}
                        {...this.props}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <EmailModal.Header closeButton className="Popupcolor">
                          <Modal.Title>Share by email</Modal.Title>
                        </EmailModal.Header>
                        <EmailModal.Body>
                          <div>
                            <div className="row mt-3 AllColPadding">
                              <div className="col-lg-6 TopicPadding">
                                <label for="To">To</label>
                                <input
                                  type="email"
                                  id="email"
                                  name="email"
                                  ref="email"
                                  className="form-control form-control-sm rounded-0"
                                  placeholder="Enter your email address(es); separated by semi-colon"
                                />
                                <span className="error">
                                  {this.state.emailRec}
                                </span>
                              </div>
                            </div>
                            <div className="row mt-3 AllColPadding">
                              <div className="col-lg-6 TopicPadding">
                                <label for="SubjectTitle">Subject</label>
                                <input
                                  type="text"
                                  ref="SubjectTitle"
                                  className="form-control form-control-sm rounded-0"
                                  placeholder={this.state.journalTitle}
                                  id="SubjectTitle"
                                  name="SubjectTitle"
                                />
                              </div>
                            </div>
                            <div className="row mt-3 AllColPadding">
                              <div className="col-lg-6 TopicPadding">
                                <label for="URL" style={{ fontSize: "12px" }}>
                                  {window.location.href}
                                </label>
                                <textarea
                                  className="form-control"
                                  id="addInfo"
                                  name="addInfo"
                                  rows="3"
                                  placeholder="Enter message"
                                  ref="AddInfo"
                                />
                              </div>
                            </div>
                          </div>
                        </EmailModal.Body>
                        <EmailModal.Footer>
                          <div className="row AllColPadding">
                            <div className="col-sm-8 TopicPadding ">
                              <span
                                variant="secondary"
                                className="Modalbutton HoverUnderline"
                                onClick={this.handleEmailModalClose}
                              >
                                {" "}
                                Return to site{" "}
                              </span>
                            </div>
                            <div className="col-sm-4 TopicPadding">
                              <button
                                variant="primary"
                                className="btn btn-info next FloatSet"
                                onClick={this.sendShareByEmail}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </EmailModal.Footer>
                      </EmailModal>

                      <div
                        className="TopicBorder BGGrey"
                        style={{
                          paddingBottom: "3%",
                          paddingTop: "3%",
                          fontSize: "18px",
                        }}
                      >
                        <span className="paddingL fontbold margintop SetPaddingforP">
                          {" "}
                          Stay up to date{" "}
                        </span>
                      </div>
                      <div
                        className="TopicBorder"
                        style={{ paddingBottom: "3%" }}
                      >
                        <br></br>
                        <a
                          className="LinkClass RSSCard Shareicon-margin"
                          style={{ cursor: "pointer" }}
                          href={"feeds/" + this.state.code}
                          target="_blank"
                          title="Open RSS feed"
                          data-tooltip="RSS feed for this title"
                        >
                          <i
                            class="fa fa-rss shareicon-ETOC colPadding btn-fa"
                            aria-hidden="true"
                          ></i>
                        </a>
                        <Link
                          to="/Etoc"
                          onClick={this.handleSelect}
                          className="RSSCard Shareicon-margin"
                          data-tooltip="Table of contents alert for this title"
                          title="Table of contents alert for this title"
                        >
                          <i
                            class="fa fa-clock-o shareicon-ETOC colPadding btn-fa"
                            aria-hidden="true"
                          ></i>
                        </Link>
                        <br></br>
                        <span
                          style={{
                            fontSize: "11px",
                            color: "#757575",
                            marginLeft: "7%",
                          }}
                        >
                          RSS
                        </span>
                        <span
                          style={{
                            fontSize: "11px",
                            color: "#757575",
                            marginLeft: "13%",
                          }}
                        >
                          ETOC
                        </span>
                        <br></br>
                      </div>

                      <div className="White"></div>

                      {this.state.ranking !== null ? (
                        <div className="TopicBorder BGGrey">
                          <div
                            className="paddingL"
                            style={{ marginTop: "4%" }}
                            dangerouslySetInnerHTML={{
                              __html: this.state.ranking,
                            }}
                          ></div>
                        </div>
                      ) : null}

                      {/* This section is responsible for showing the Ranking Box */}
                      <RankingTag name={this.state.journalTitle} />
                    </div>
                  </div>
                </div>
                <div className="White"></div>
              </div>
            </div>
          </DocumentMeta>
        ) : (
          <Maintenance />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Journals/JournalPublication.jsx